import {
    SOCIAL_COMPLETE_SIGNUP_FAILURE,
    SOCIAL_COMPLETE_SIGNUP_SUCCESS,
    SOCIAL_LOGIN_FAILURE,
    SOCIAL_LOGIN_NEEDS_COMPLETION,
    SOCIAL_LOGIN_TRIGGER,
    SOCIAL_SKIP_PROFILE_UPDATE,
    SOCIAL_UPDATE_PROFILE_FAILURE,
    SOCIAL_UPDATE_PROFILE_SUCCESS,
    SocialAuthAction,
} from "@/mk2/apps/users/containers/SocialAuth/SocialAuth.actions";
import { SocialProvider } from "@/mk2/apps/users/lib/socialAuth/types";

export interface SocialAuthState {
    loading: boolean;
    provider: SocialProvider | null;
    needsCompletion: boolean;
    prefill: {
        email?: string;
        fullName?: string;
        avatarUrl?: string;
    } | null;
    error: string | null;
    step: "mandatory" | "optional";
}

const initialState: SocialAuthState = {
    loading: false,
    provider: null,
    needsCompletion: false,
    prefill: null,
    error: null,
    step: "mandatory",
};

export function socialAuthReducer(
    state: SocialAuthState = initialState,
    action: SocialAuthAction,
): SocialAuthState {
    switch (action.type) {
        case SOCIAL_LOGIN_TRIGGER:
            return {
                ...state,
                loading: true,
                provider: action.provider,
                error: null,
            };
        case SOCIAL_LOGIN_NEEDS_COMPLETION:
            return {
                ...state,
                loading: false,
                needsCompletion: true,
                provider: action.provider,
                prefill: action.prefill,
                step: "mandatory",
            };
        case SOCIAL_LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case SOCIAL_COMPLETE_SIGNUP_SUCCESS:
            return {
                ...state,
                loading: false,
                step: "optional",
                error: null,
            };
        case SOCIAL_COMPLETE_SIGNUP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case SOCIAL_UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case SOCIAL_UPDATE_PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case SOCIAL_SKIP_PROFILE_UPDATE:
            return {
                ...state,
                loading: false,
                error: null,
            };
        default:
            return state;
    }
}
